import EmptyPage from '@/pages/EmptyPage.vue'

const LoginPage = () => import('@/pages/login/LoginPage.vue')
const ForgotPasswordPage = () => import('@/pages/forgot-password/ForgotPasswordPage.vue')
const ResetPasswordPage = () => import('@/pages/forgot-password/ResetPasswordPage.vue')
const InvitePage = () => import('@/pages/InvitePage.vue')
const HomePage = () => import('@/pages/HomePage.vue')
const AccessCallbackPage = () => import('@/pages/AccessCallbackPage.vue')
const HiddePdfPageRri = () => import('@/pages/hidden/profile-rri/pdf/_slug.vue')
const ProfilePreviewPage = () => import('@/pages/profile/ProfilePreviewPage.vue')
const EmbedUserSyncPage = () => import('@/pages/EmbedUserSyncPage.vue')
const NotFoundPage = () => import('@/pages/ErrorPage.vue')
const AttachmentPreviewProxy = () => import('@/pages/attachment/AttachmentPreviewProxy.vue')


import accountRoutes from '@/routes/account.js'
import profileRoutes from '@/routes/profile.js'
import notificationsRoutes from '@/routes/notifications.js'
import jobsRoutes from '@/v2/pages/jobs/routes.ts'
import jobRoutes from '@/v2/pages/job/routes.ts'
import candidateRoutes from '@/routes/candidate.js'
import helpRoutes from '@/v2/pages/help/routes.ts'
import gdprRoutes from '@/v2/pages/gdpr/routes.ts'
import uiKitRoutes from '@/routes/ui-kit.js'

export default [
  {
    path: '/:locale(en|de)?',
    component: EmptyPage,
    children: [
      {
        path: '',
        name: 'Home',
        component: HomePage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: {
          layout: 'auth',
          requiresAuth: false
        }
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: ForgotPasswordPage,
        meta: {
          layout: 'auth',
          requiresAuth: false
        }
      },
      {
        path: 'reset-password/:token',
        name: 'ResetPassword',
        component: ResetPasswordPage,
        meta: {
          layout: 'auth',
          requiresAuth: false
        }
      },
      {
        path: 'invite/:token',
        name: 'Invite',
        component: InvitePage,
        meta: {
          layout: 'auth',
          requiresAuth: false
        }
      },
      {
        path: 'access-callback',
        name: 'AccessCallbackPage',
        component: AccessCallbackPage,
        meta: {
          layout: 'empty',
          requiresAuth: false
        }
      },
      {
        path: 'hidden/profile-rri/pdf/:slug',
        name: 'HiddePdfPageRri',
        component: HiddePdfPageRri,
        meta: {
          layout: 'empty',
          requiresAuth: false,
          pdf: true
        }
      },
      {
        path: 'attachments/preview/:rest(.*)',
        name: 'AttachmentPreviewProxy',
        component: AttachmentPreviewProxy,
        meta: {
          layout: 'empty',
          requiresAuth: false
        }
      },
      ...jobRoutes,
      {
        path: 'profile/preview/:slug',
        name: 'ProfilePreviewPage',
        component: ProfilePreviewPage,
        meta: {
          layout: 'empty',
          requiresAuth: false
        }
      },
      {
        path: 'embed/user-sync',
        name: 'EmbedUserSync',
        component: EmbedUserSyncPage,
        meta: {
          layout: 'empty',
          requiresAuth: false,
          styles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }
        }
      },
      ...accountRoutes,
      ...profileRoutes,
      ...notificationsRoutes,
      ...jobsRoutes,
      ...candidateRoutes,
      ...helpRoutes,
      ...gdprRoutes,
      ...uiKitRoutes
    ]
  },
  {
    path: '/:locale(en|de)?/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: {
      status: 404,
      layout: 'error'
    }
  }
]
